module.exports = __webpack_public_path__ + "4f515f4796ac6493e76055736a0ad6ad.pdf";